import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  openFilterModal
} from "../../actions/historyActions";

import ClearFilters from "./ClearFilters";

export function SearchFilters({ openFilters }) {
  return (
    <div className="row filterSearch">
      <div className="col-sm-7 col-xs-7 searchHistoryFilter">
        <button
          className="btn-block btn-filter"
          onClick={openFilters}
        >
          <img
            src={require("./assets/searchIcon.png")}
            alt="Mentor Graphics Time Tracker"
          />
          Filter
        </button>
      </div>
      <div className="col-sm-5 col-xs-5 text-right clearSearchHistoryFilter">
        <ClearFilters />
      </div>
    </div>
  );
}

SearchFilters.displayName = "History.SearchFilters";

SearchFilters.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  openFilters: PropTypes.func.isRequired,
};

SearchFilters.defaultProps = {
  isOpen: false,
};

function mapStateToProps(state, ownProps) {
  return {
    isOpen: state.historyFilters.modalOpen,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openFilters: () => {
      dispatch(openFilterModal());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilters);



// WEBPACK FOOTER //
// ./app/components/History/SearchFilters.jsx